import { readCookie, writeCookie } from './cookie'

const QUERY_PARAM = 'el_cid'

/**
 * 현재 페이지 URL에서 `?el_cid=`를 감지해 1st-party 쿠키 `_el_cid`로 옮긴다.
 * 부착된 파라미터는 `history.replaceState`로 URL에서 제거해 사용자에게 노출되지 않게 한다.
 *
 * SPA 라우터(React Router/Next router)와의 충돌을 피하기 위해 로드 직후 한 번만 실행한다.
 *
 * @returns 캡처된 clickId (저장된 값). 없으면 null.
 */
const captureClickIdFromUrl = (cookieDomain?: string): string | null => {
  if (typeof window === 'undefined' || typeof location === 'undefined') return null

  const searchParams = new URLSearchParams(location.search)
  const clickIdFromUrl = searchParams.get(QUERY_PARAM)

  if (clickIdFromUrl != null && clickIdFromUrl !== '') {
    writeCookie(clickIdFromUrl, { domain: cookieDomain })
    // URL에서 el_cid 제거 (사용자 시야에서 숨김 + 새로고침 시 중복 캡처 방지)
    searchParams.delete(QUERY_PARAM)
    const cleanQuery = searchParams.toString()
    const newUrl = `${location.pathname}${cleanQuery !== '' ? `?${cleanQuery}` : ''}${location.hash}`
    history.replaceState(history.state, '', newUrl)
    return clickIdFromUrl
  }

  return readCookie()
}

export { captureClickIdFromUrl, QUERY_PARAM }
